<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

interface Props {
  labelKey?: string
  label?: string
  helpKey: string
  iconPosition?: 'before' | 'after'
  maxWidth?: number
}

const props = withDefaults(defineProps<Props>(), {
  labelKey: '',
  label: '',
  iconPosition: 'after',
  maxWidth: 420,
})

const { t } = useI18n()
const labelText = computed(() => props.label || (props.labelKey ? t(props.labelKey) : ''))
</script>

<template>
  <span class="question-help-label" :class="`is-${iconPosition}`">
    <QuestionHelp
      v-if="iconPosition === 'before'"
      :help-key="helpKey"
      :max-width="maxWidth"
    />
    <span class="question-help-label__text">{{ labelText }}</span>
    <QuestionHelp
      v-if="iconPosition === 'after'"
      :help-key="helpKey"
      :max-width="maxWidth"
    />
  </span>
</template>

<style scoped>
.question-help-label {
  display: inline-flex;
  flex-wrap: nowrap;
  gap: 6px;
  align-items: center;
  min-width: 0;
  line-height: inherit;
  vertical-align: middle;
}

.question-help-label :deep(.question-help) {
  margin: 0;
}

.question-help-label__text {
  display: inline-block;
  min-width: 0;
  line-height: inherit;
  vertical-align: middle;
}
</style>
